<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">{{ operacion() }}Producto</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        <form (ngSubmit)="saveProducto()" [formGroup]="myAccountProducto">

          <!-- Nombre -->
          <div class="mb-4 mt-2 text-start">
            <label for="nombre" class="form-label"><b>Nombre del producto</b></label>
            <input
              type="text"
              class="form-control"
              id="nombre"
              formControlName="nombre"
              placeholder="Ingrese un nombre"
            />

            @if (myAccountProducto.controls.nombre.invalid &&
                 (myAccountProducto.controls.nombre.dirty || myAccountProducto.controls.nombre.touched) &&
                 myAccountProducto.controls.nombre.errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">El nombre es requerido</small>
              </div>
            }
          </div>

          <!-- Descripción -->
          <div class="mb-4 mt-2 text-start">
            <label for="descripcion" class="form-label"><b>Descripcion del producto</b></label>
            <input
              type="text"
              class="form-control"
              id="descripcion"
              formControlName="descripcion"
              placeholder="Ingrese una descripción"
            />

            @if (myAccountProducto.controls.descripcion.invalid &&
                 (myAccountProducto.controls.descripcion.dirty || myAccountProducto.controls.descripcion.touched) &&
                 myAccountProducto.controls.descripcion.errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">La descripción es requerida</small>
              </div>
            }
          </div>

          <!-- Precio / Descuento -->
          <div class="row mt-4 align-items-center">
            <div class="col col-6 align-middle pe-2">
              <label for="precio" class="form-label"><b>Precio</b></label>
              <input
                type="text"
                inputmode="decimal"
                class="form-control"
                id="precio"
                formControlName="precio"
                placeholder="Ej: 1250,50"
                (input)="onPrecioInput($event)"
              />

              @if (myAccountProducto.controls.precio.invalid &&
                   (myAccountProducto.controls.precio.dirty || myAccountProducto.controls.precio.touched)) {
                <div class="alert-danger" role="alert">
                  <small class="alert">Ingrese un precio válido</small>
                </div>
              }
            </div>

            <div class="col col-6 align-middle ps-2">
              <label for="porcentaje_descuento" class="form-label"><b>% de descuento</b></label>
              <input
                type="text"
                inputmode="decimal"
                class="form-control"
                id="porcentaje_descuento"
                formControlName="porcentaje_descuento"
                placeholder="0 a 100 (Ej: 10,50)"
                (input)="onDescuentoInput($event)"
              />

              @if (myAccountProducto.controls.porcentaje_descuento.invalid &&
                   (myAccountProducto.controls.porcentaje_descuento.dirty || myAccountProducto.controls.porcentaje_descuento.touched)) {
                <div class="alert-danger" role="alert">
                  <small class="alert">El % debe estar entre 0 y 100</small>
                </div>
              }
            </div>
          </div>

          <!-- SKU -->
          <div class="mb-4 mt-4 text-start">
            <label for="sku" class="form-label"><b>SKU del producto</b></label>
            <input
              type="text"
              class="form-control"
              id="sku"
              formControlName="sku"
              placeholder="Ingrese una # de SKU"
            />

            @if (myAccountProducto.controls.sku.invalid &&
                 (myAccountProducto.controls.sku.dirty || myAccountProducto.controls.sku.touched) &&
                 myAccountProducto.controls.sku.errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">El SKU es requerido</small>
              </div>
            }
          </div>

          <!-- Imagen -->
          <div class="row mt-4 align-items-center">
            <div class="col align-middle">
              <label class="form-label mb-0" style="font-size: 0.9em;">
                <b>Imagen del producto</b>
              </label>
            </div>

            <div class="col">
              @if (preview_img_producto(); as img) {

                <div class="credencial-wrapper">
                  <div class="credencial-actions">
                    <div class="credencial-action-icon" (click)="capturarFileImgProducto()">
                      <i class="bi bi-pencil"></i>
                    </div>
                    @if (hayImagenParaEliminar()) {
                      <div class="credencial-action-icon delete-credential" (click)="eliminarImgProducto()">
                        <i class="bi bi-trash"></i>
                      </div>
                    }
                  </div>

                  <div class="file fileupload bg-transparent text-center align-items-center justify-content-center">
                    <img
                      width="100px"
                      [src]="img"
                      alt="Foto de Producto"
                      class="imgproduct producto-image"
                      (click)="openModal()"
                    />
                  </div>
                </div>

              } @else {

                <div class="file fileupload bg-transparent text-center align-items-center justify-content-center">
                  <div class="btn file fileupload m-0 mt-0">
                    <div style="background-color: transparent;" (click)="capturarFileImgProducto()">
                      <label>Cargar</label> Imagen del producto
                    </div>
                  </div>
                </div>

              }
            </div>
          </div>

          <!-- Modal Preview IMG PRODUCTO -->
          <div class="modal fade" id="modalPreviewImgProducto" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Producto</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                  @if (preview_img_producto(); as img) {
                    <img [src]="img" class="img-fluid producto-image" />
                  }
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal confirmar eliminar imagen -->
          <div class="modal fade" id="modalConfirmarEliminarImagenProducto" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content confirmar-eliminar-content">
                <div class="modal-body text-center pt-4 pb-2">
                  <div class="confirmar-eliminar-icono">
                    <i class="bi bi-trash"></i>
                  </div>
                  <h5 class="mt-3 mb-2">Eliminar imagen</h5>
                  <p class="text-muted mb-0">¿Querés eliminar la imagen del producto? Esta acción no se puede deshacer.</p>
                </div>
                <div class="modal-footer border-0 pt-2 pb-4 justify-content-center">
                  <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>
                  <button type="button" class="btn btn-danger rounded-pill px-4" (click)="confirmarEliminarImgProducto()">Eliminar</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Error -->
          @if (error(); as err) {
            @if (err.length > 0) {
              <div class="alert alert-danger mt-2" role="alert">
                <small>{{ err }}</small>
              </div>
            }
          }

          <!-- Guardar -->
          <div class="d-grid mt-5 mb-3 pb-3">
            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
              {{ loading() ? 'Cargando...' : (botonOperacion() + 'Producto') }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
